export const ShareCopy = {
  Title: 'My TABTouch Bet',
  MessageWin: "I've got the touch! Check out this bet I placed on TABtouch.\n",
  MessagePending: "Here's hoping I've got the touch! Check out this bet I placed on TABtouch.\n",
  MessageNoPayout: "I'll have the touch next time! Check out this bet I placed on TABtouch.\n",
  MessageDefault: 'Check out this bet I placed on TABtouch.\n',
  MessageUnplaced: 'Have you got the touch? Check out this bet on TABtouch.\n',
} as const
